import { createSlice } from "@reduxjs/toolkit";
export const agentAccountSlice = createSlice({
  name: "agentAccountSlice",
  initialState: {
    agentAccountFilter: {},
  },
  reducers: {
    setagentAccountFilter: (state, action) => {
      return { ...state, agentAccountFilter: action.payload };
    },
    ResetagentAccountFilter: (state, action) => {
      return { agentAccountFilter: {} };
    },
  },
});

export const { setagentAccountFilter, ResetagentAccountFilter } = agentAccountSlice.actions;

export default agentAccountSlice.reducer;
